import { Controller } from '@hotwired/stimulus'
import uniqWith from 'lodash/uniqWith'
import template from 'lodash/template'
import compact from 'lodash/compact'
import { forEach } from 'lodash'
// import difference from 'loadash/difference'

export const buildQueryParamter = (params) => {
  const query = new URLSearchParams()
  query.set('criteria[admission_fee]', params.admissionFee)
  query.set('criteria[monthly_fee]', params.monthlyFee)
  query.set('criteria[distance]', params.distance)
  query.set('criteria[welfare]', params.welfare)
  query.set('criteria[joint_surety]', params.joint_surety)
  query.set('criteria[searvice_area]', params.searvice_area)
  query.set('criteria[facility_introduction_type]', params.facilityIntroductionType)
  query.set('criteria[vacancies_exist_for_admin]', params.vacanciesExistForAdmin)
  query.set('criteria[food_plan_exist]', params.foodPlanExist)
  query.set('criteria[dementia_acceptance]', params.dementiaAcceptance)
  query.set('criteria[waiting_for_vacancy', params.waitingForVacancy)

  params.categoryIds.forEach((id) => { query.append('criteria[category_ids][]', id) })
  params.featureIds.forEach((id) => { query.append('criteria[feature_content_ids][]', id) })
  params.careLevelIds.forEach((id) => { query.append('criteria[care_level_ids][]', id) })
  params.medicalCareIds.forEach((id) => { query.append('criteria[medical_care_ids][]', id) })

  if (params.location) {
    query.set('criteria[location][lat]', params.location?.lat)
    query.set('criteria[location][lng]', params.location?.lng)
  }
  return query.toString()
}

export default class extends Controller {
  static values = {
    selectedFacilities: Array,
    deletedFacilityIds: Array,
    requestId: Number,
  }

  static targets = [
    'map', // googlemap
    'result', // 提案リスト
    'area', // 地図検索
    'distance', // 距離

    // 初期
    'defaultArea',

    // リスト
    'searchresult',
    'searchResultTemplate',
    'loading',

    // 検索パラメータ
    'category',
    'admissionFee',
    'monthlyFee',
    'feature',
    'medicalCare',
    'careLevel',
    'facilityIntroductionType',
    'welfare',
    'jointSurety',
    'searviceArea',
    'vacanciesExistForAdmin',
    'foodPlanExist',
    'dementiaAcceptance',
    'waitingForVacancy',

    // 表示ならべかえ
    'order',

    // 検索条件に関する項目
    'mapSearchAttributes',
  ]

  get params () {
    return {
      location: this.location,
      distance: this.distanceTarget.value,
      admissionFee: this.admissionFeeTarget.value,
      monthlyFee: this.monthlyFeeTarget.value,
      facilityIntroductionType: this.facilityIntroductionTypeTarget.value,
      welfare: this.welfareTarget.value,
      joint_surety: this.jointSuretyTarget.value,
      searvice_area: this.searviceAreaTarget.value,
      vacanciesExistForAdmin: this.vacanciesExistForAdminTarget.value,
      foodPlanExist: this.foodPlanExistTarget.value,
      dementiaAcceptance: this.dementiaAcceptanceTarget.value,
      waitingForVacancy: this.waitingForVacancyTarget.value,
      featureIds: compact(this.featureTargets.map((checkbox) => checkbox.checked ? checkbox.value : null)),
      categoryIds: compact(this.categoryTargets.map((checkbox) => checkbox.checked ? checkbox.value : null)),
      careLevelIds: compact(this.careLevelTargets.map((checkbox) => checkbox.checked ? checkbox.value : null)),
      medicalCareIds: compact(this.medicalCareTargets.map((checkbox) => checkbox.checked ? checkbox.value : null)),
    }
  }

  get location () {
    return this.map.getCenter()?.toJSON()
  }

  get map () {
    if (this._map) return this._map

    return this.initializeMap()
  }

  connect () {
    this.updateSelectedFacilities()
    this.searchResultTemplate = template(this.searchResultTemplateTarget.innerHTML)

    if (typeof (google) !== 'undefined') {
      this.initializeMap()
      this.searchBindingBox()
    }
  }

  initializeMap () {
    const map = new google.maps.Map(this.mapTarget, {
      center: new google.maps.LatLng(
        35.66458844, 139.73776658,
      ),
      zoom: 17,
      fullscreenControl: false,
      mapTypeControl: false,
    })

    const defaultArea = JSON.parse(this.element.dataset.defaultArea || 'null')
    if (defaultArea) {
      this.areaTarget.value = defaultArea.fullName
      const boundingBox = defaultArea.boundingBox
      map.fitBounds(
        new google.maps.LatLngBounds(
          new google.maps.LatLng(boundingBox.sw.lat, boundingBox.sw.lng),
          new google.maps.LatLng(boundingBox.ne.lat, boundingBox.ne.lng),
        ),
      )
      setTimeout(() => {
        map.setZoom(15)
      }, 500)
    }
    this._map = map
    // this._map.addListener('bounds_changed', () => {
    this._map.addListener('dragend', () => {
      this.searchBindingBox()
    })

    this.infowindow = new google.maps.InfoWindow({ content: '' })
    console.log('initializeMap')
    return this._map
  }

  updateSelectedFacilities () {
    if (this.selectedFacilitiesValue.length === 0) {
      this.resultTarget.innerHTML = ''
      return
    }

    const list = this.selectedFacilitiesValue.map(
      (facility) => `
      <li
        class="list-group-item"
        data-facility="${facility.id}"
        data-action="mouseover->${this.element.dataset.controller}#registeredFacilityMouseover
        mouseout->${this.element.dataset.controller}#registeredFacilityMouseout"
      >
        <input type="hidden" name="facility_ids[]" value="${facility.id}" />
        <div class="d-flex">
          <a href="javascript:void(0)" data-url="/admin/ca/request/map/facilities/${facility.id}/?request_id=${this.requestIdValue}" data-behavior="dialog">
            ${facility.name}
          </a>
          <div class="ml-2">
            ${facility.has_facility_special_unit_price ? '<span class="special-measure-label special-unit-label">特</span>' : ''}
            ${facility.has_facility_campaign ? '<span class="special-measure-label campaign-label">キ</span>' : ''}
          </div>
        </div>
        <div class="d-flex align-items-center">
          <div class="facility-category ${facility.category.show_category_name ? facility.category.slug : ''}">
            <b>${facility.category.show_category_name ? facility.category.name.slice(0, 1) : '他'}</b>
          </div>
          <small class="ml-2">${facility.facility_address}</small>
          <small class="ml-2">月額: <strong class="text-danger">${facility.monthly_price_range}</strong></small>
          <small class="ml-2">成約: <strong class="text-danger">${facility.contract_unit_price}</strong></small>
        </div>
      </li>
      `)

    list.unshift(`
      <li class="list-group-item">
        <span>登録済み施設</span>
      </li>
    `)
    this.resultTarget.innerHTML = list.join('')
  }

  get header () {
    const element = document.head.querySelector('meta[name="csrf-token"]')

    return {
      'Content-Type': 'application/json',
      'X-CSRF-TOKEN': element.content,
    }
  }

  async add (e) {
    const url = '/api/admin/ca/request/facilities'

    await fetch(url, {
      method: 'POST',
      headers: this.header,
      body: JSON.stringify({ request_id: this.requestIdValue, facility_id: e.target.dataset.value }),
    })
      .then(response => {
        if (response.ok) return response.json()
        throw new Error(response.statusText)
      })
      .then(data => {
        const origin = this.selectedFacilitiesValue
        origin.push({
          id: Number(e.target.dataset.value),
          name: e.target.dataset.label,
          has_facility_special_unit_price: data.has_facility_special_unit_price,
          has_facility_campaign: data.has_facility_campaign,
          category: data.category,
          facility_address: data.facility_address,
          monthly_price_range: data.monthly_price_range,
          contract_unit_price: data.contract_unit_price,
        })

        const list = uniqWith(origin, (org, oth) => (org.id === oth.id))
        this.selectedFacilitiesValue = list

        this.deletedFacilityIdsValue = this.deletedFacilityIdsValue.filter(facilityId => {
          return facilityId !== data.facilityId
        })

        this.updateSelectedFacilities()
        this.updateSearchResult(this.facilities)
        this.updateMarker(this.facilities)
      })
      .catch(error => {
        console.log(error)
        alert('施設を登録できませんでした。')
      })
  }

  async delete (e) {
    await this.deleteFacility(e.target.dataset.caRequestFacilityId, e.target.dataset.facilityId, false)
  }

  // Issue #13554: 未送付の紹介カードがある提案施設の解除は、サーバが 409(requiresConfirmation) を返す。
  // 確認ダイアログでユーザーが同意した場合のみ confirmed=true で再送し、送付漏れを防ぐ。
  async deleteFacility (caRequestFacilityId, facilityId, confirmed) {
    let url = `/api/admin/ca/request/facilities/${caRequestFacilityId}?request_id=${this.requestIdValue}&facility_id=${facilityId}`
    if (confirmed) url += '&confirmed=true'

    try {
      const response = await fetch(url, {
        method: 'DELETE',
        headers: this.header,
      })

      if (response.status === 409) {
        const body = await response.json()
        if (body.requiresConfirmation && window.confirm(body.message)) {
          await this.deleteFacility(caRequestFacilityId, facilityId, true)
        }
        return
      }

      if (!response.ok) throw new Error(response.statusText)

      const data = await response.json()
      const origin = this.selectedFacilitiesValue
      const list = origin.filter(item => item.id !== data.facilityId)
      this.selectedFacilitiesValue = list

      const newDeletedFacilityIds = [...this.deletedFacilityIdsValue, data.facilityId]
      this.deletedFacilityIdsValue = newDeletedFacilityIds

      this.updateSelectedFacilities()
      this.updateSearchResult(this.facilities)
      this.updateMarker(this.facilities)
    } catch (error) {
      console.log(error)
      alert('施設を削除できませんでした。')
    }
  }

  move (facility) {
    if (facility == null) return

    const center = new google.maps.LatLng(
      parseFloat(facility.address.latitude),
      parseFloat(facility.address.longitude),
    )
    this.map.panTo(center)
  }

  mouseover (e) {
    e.preventDefault()
    e.stopPropagation()
    const facilityId = parseInt(e.currentTarget.dataset.facility)
    // this.move(facility)

    this.focusInfowindow(facilityId, true)
    window.location.href = `#facility-${facilityId}`
  }

  mouseout (e) {
    e.preventDefault()
    e.stopPropagation()
    const facilityId = parseInt(e.currentTarget.dataset.facility)
    // this.move(facility)
    this.focusInfowindow(facilityId, false)
  }

  registeredFacilityMouseover (e) {
    e.preventDefault()
    e.stopPropagation()

    if (!this.infowindows) return

    const facilityId = parseInt(e.currentTarget.dataset.facility)
    this.focusRegisterdMarker(facilityId, true)
    this.focusInfowindow(facilityId, true)
    window.location.href = `#facility-${facilityId}`
  }

  registeredFacilityMouseout (e) {
    e.preventDefault()
    e.stopPropagation()

    if (!this.infowindows) return

    const facilityId = parseInt(e.currentTarget.dataset.facility)
    this.focusRegisterdMarker(facilityId, false)
    this.focusInfowindow(facilityId, false)
  }

  focusRegisterdMarker (facilityId, shown) {
    const element = document.getElementById(`marker-facility-${facilityId}`)
    if (!element) return

    if (shown) {
      element.classList.add('focus')
    } else {
      element.classList.remove('focus')
    }
  }

  focusList (e) {
    const facilityId = parseInt(e.currentTarget.dataset.facility)
    this.focusInfowindow(facilityId, true)
  }

  focusoutList (e) {
    const facilityId = parseInt(e.currentTarget.dataset.facility)
    this.focusInfowindow(facilityId, false)
  }

  focusInfowindow (facilityId, shown) {
    const infowindow = this.findInfoWindow(facilityId)
    if (!infowindow) return
    const element = document.getElementById(`infowindow-${facilityId}`)

    if (shown) {
      infowindow.setZIndex(1001)
      element.style.borderBottom = '3px#F4BC70 solid'
      document.getElementById(`facility-${facilityId}`).style.border = '3px#F4BC70 solid'
    } else {
      element.style.borderBottom = '0'
      infowindow.setZIndex(-1)
      document.getElementById(`facility-${facilityId}`).style.border = '0'
    }
  }

  findInfoWindow (facilityId) {
    return this.infowindows.find((infowindow) => facilityId === infowindow.facilityId)
  }

  moveLocation (e) {
    e.preventDefault()
    e.stopPropagation()

    const geocoder = new google.maps.Geocoder()
    geocoder.geocode({ address: this.areaTarget.value }, (results, _status) => {
      this.map.panTo(results[0].geometry.location)
      this.searchBindingBox()
    })
    return false
  }

  searchBindingBox () {
    if (!this.location) return

    this.showLoading()
    fetch(this.element.dataset.searchPath + '?' + buildQueryParamter(this.params))
      .then(response => response.json())
      .then(facilities => {
        this.facilities = facilities
        this.updateSearchResult(facilities)
        this.updateMarker(facilities)
      })
  }

  search (e) {
    e.preventDefault()
    e.stopPropagation()

    this.showLoading()

    fetch(this.element.dataset.searchPath + '?' + buildQueryParamter(this.params))
      .then(response => response.json())
      .then((facilities) => {
        this.facilities = facilities
        this.updateSearchResult(facilities)
        this.updateMarker(facilities)
        this.move(facilities[0])
      })

    return false
  }

  reorder () {
    switch (this.orderTarget.value) {
      case 'distance':
        this.facilities = this.facilities.sort((a, b) => a.distance - b.distance)
        break
      case 'cheap-admission-fee':
        this.facilities = this.facilities.sort((a, b) => a.plans.admission.low - b.plans.admission.low)
        break
      case 'expensive-admission-fee':
        this.facilities = this.facilities.sort((a, b) => b.plans.admission.high - a.plans.admission.high)
        break
      case 'cheap-monthly-fee':
        this.facilities = this.facilities.sort((a, b) => a.plans.monthly.low - b.plans.monthly.low)
        break
      case 'expensive-monthly-fee':
        this.facilities = this.facilities.sort((a, b) => b.plans.monthly.high - a.plans.monthly.high)
        break
      case 'near-station':
        this.facilities = this.facilities.sort((a, b) => (
          (a.near_station_distance || 99999999) - (b.near_station_distance || 99999999)
        ))
        break
    }
    this.updateSearchResult(this.facilities)
  }

  showLoading () {
    this.loadingTarget.style.display = 'block'
  }

  hideLoading () {
    this.loadingTarget.style.display = 'none'
    this.orderTarget.style.display = 'block'
  }

  updateSearchResult (facilities) {
    this.hideLoading()
    this.searchresultTarget.innerHTML = facilities.map((facility) => {
      return this.searchResultTemplate({ facility, forEach })
    }).join('')
  }

  clickListItem (e) {
    const facilityId = parseInt(e.target.dataset.facility)
    const facility = this.facilities.find((facility) => facility.id === facilityId)
    this.move(facility)
  }

  updateMarker (facilities) {
    this.markers?.forEach((marker) => marker.setMap(null))
    this.markers = facilities.map((facility) => {
      const marker = new google.maps.Marker({
        visible: false,
        map: this.map,
        anchorPoint: new google.maps.Point(0, 0),
        zIndex: 1,
        facilityId: facility.id,
        facility,
        label: {
          text: facility.name,
          color: '#000',
          fontSize: '15px',
          fontWeight: 'bold',
        },
      })
      marker.setPosition({
        lat: parseFloat(facility.address.latitude),
        lng: parseFloat(facility.address.longitude),
      })

      return marker
    })
    this.infowindows?.forEach((infowindow) => infowindow.setMap(null))
    this.infowindows = this.markers.map((marker) => {
      const facility = marker.facility

      let classList = `${this.element.dataset.cssRootSelector}::maker target`
      const url = `/admin/ca/request/map/facilities/${facility.id}/?request_id=${this.requestIdValue}`
      let deletedLabel = ''
      let specialUnitPriceLabel = ''
      let campaignLabel = ''

      if (this.deletedFacilityIdsValue.includes(facility.id)) {
        deletedLabel = '<span>取消済</span>'
        classList = classList + ' ' + 'deleted-facility'
      }

      if (facility.special_unit_prices.length) {
        specialUnitPriceLabel = '<span class="special-measure-label special-unit-label">特単</span>'
      }

      if (facility.campaigns.length) {
        campaignLabel = '<span class="special-measure-label campaign-label">キャンペーン</span>'
      }

      const isRegisteredFacility = this.selectedFacilitiesValue.some((selectedFacility) => selectedFacility.id === facility.id)
      if (isRegisteredFacility) {
        classList = classList + ' ' + 'registered-facility'
      }

      if (facility.has_decisition_at) {
        classList = classList + ' ' + 'decided-admission-facility'
      }

      const content = `
        <div id="infowindow-${facility.id}"
          class="${classList}"
          data-facility="${facility.id}"
          data-action="mouseover->${this.element.dataset.controller}#mouseover mouseout->${this.element.dataset.controller}#mouseout">
          <div class="mb-1">
            ${specialUnitPriceLabel}
            ${campaignLabel}
          </div>
          ${deletedLabel}
          <small>${facility.category.name}</small>
          <a class="d-block text-center" data-url=${url} data-behavior="dialog">${facility.name}</a>
          <div class="ml-1">
            <small>${facility.address.prefecture.name}</small>
            <small>${facility.address.city.name}</small>
          </div>
          <div class="text-muted">
            <small>月額: <strong class="text-danger">${facility.monthly_price_range}</strong></small>
            <br>
            <small>成約: <strong class="text-danger">${facility.contract.contract_fee}</strong></small>
          </div>
        </div>
      `

      const infowindow = new google.maps.InfoWindow({ facilityId: facility.id, content, disableAutoPan: true })
      infowindow.open(this.map, marker)

      this.addClassToInfoWIndows(infowindow, facility.id)

      return infowindow
    })
  }

  addClassToInfoWIndows (infoWindow, facilityId) {
    google.maps.event.addListenerOnce(infoWindow, 'domready', () => {
      document.querySelectorAll('.gm-style-iw-t').forEach(iwOuter => {
        const infoWindowElement = iwOuter.querySelector(`#infowindow-${facilityId}`)
        if (infoWindowElement) {
          iwOuter.id = `marker-facility-${facilityId}`
        }
        iwOuter.classList.add('searchable')

        // 取消済みラベルのスタイル用のclass追加
        const deletedFacilityElement = iwOuter.querySelector('.deleted-facility')
        if (deletedFacilityElement) {
          iwOuter.classList.add('deleted-label')
        }

        // 登録済み施設のスタイル用のclass追加
        const registeredFacilityElement = iwOuter.querySelector('.registered-facility')
        if (registeredFacilityElement) {
          iwOuter.classList.add('registered')
        }

        // 入居意思決定がされた施設のスタイル用のclass追加
        const decideAddmissionFacilityElement = iwOuter.querySelector('.decided-admission-facility')
        if (decideAddmissionFacilityElement) {
          iwOuter.classList.add('decided-admission')
        }
      })
    })
  }

  reflectCandidate (e) {
    this.resetMapSearchAttributes()
    e.currentTarget.style.border = '1px solid #ffff00'
    const requestId = e.currentTarget.dataset.request
    const candidateTab = e.currentTarget.id
    fetch(`/api/admin/ca/requests/${requestId}/map_search_attributes/?candidate_tab=${candidateTab}`)
      .then(response => response.json())
      .then(mapSearchAttributes => {
        this.reflectMapSearchAttributes(mapSearchAttributes)
      })
    if (candidateTab === 'candidate_one_and_two') {
      document.getElementById('feature_ids_202').checked = true
    }
  }

  reflectMapSearchAttributes (mapSearchAttributes) {
    Object.keys(mapSearchAttributes).forEach((key) => {
      if (mapSearchAttributes[key].bool) {
        const element = document.getElementById(mapSearchAttributes[key].id)
        switch (element.nodeName) {
          case 'INPUT':
            element.checked = true
            break
          case 'SELECT':
            element.selectedIndex = mapSearchAttributes[key].selectIndex
        }
      }
    })
  }

  resetMapSearchAttributes () {
    const candidateTabsId = ['candidate_one', 'candidate_two', 'candidate_one_and_two']
    candidateTabsId.forEach((id) => {
      document.getElementById(id).style.border = null
    })
    document.map_search_form.reset()
  }
}
